module.exports = __webpack_public_path__ + "static/media/BGnewReportOnlyImg.ef9e669a.png";